import React, { Component } from "react"
import PropTypes from "prop-types"
import SbEditable from "storyblok-react"
import { unified } from "unified"
import remarkParse from "remark-parse"
import remarkRehype from "remark-rehype"
import rehypeReact from "rehype-react"
import Button from "../button"
import remarkReactComponents from "../../helpers/remarkReactComponents"
import {
  privacyCookieAccepted,
  acceptPrivacyCookie,
} from "../../helpers/handleCookies"

class CookieNotice extends Component {
  hideNotice = () => {
    if (this.el) this.el.classList.add("cookie-notice--hidden")
  }

  componentDidMount() {
    if (this.el && !privacyCookieAccepted())
      this.el.classList.remove("cookie-notice--hidden")
  }

  render() {
    const { blok } = this.props
    return (
      <SbEditable content={blok}>
        <div
          className="cookie-notice cookie-notice--hidden"
          ref={(ref) => (this.el = ref)}
        >
          <div className="container container--no-pad cookie-notice__container">
            <div className="cookie-notice__copy">
              {
                unified()
                  .use(remarkParse)
                  .use(remarkRehype)
                  .use(rehypeReact, {
                    createElement: React.createElement,
                    components: remarkReactComponents,
                    Fragment: React.Fragment,
                  })
                  .processSync(blok.copy).result
              }
            </div>
            <div className="cookie-notice__actions">
              {blok.button_label && (
                <Button
                  text={blok.button_label}
                  iconName={blok.button_icon}
                  className="cookie-notice__btn btn--sm-wide"
                  onClick={() => {
                    acceptPrivacyCookie()
                    this.hideNotice()
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </SbEditable>
    )
  }
}

CookieNotice.propTypes = {
  blok: PropTypes.shape({
    copy: PropTypes.string,
    button_label: PropTypes.string,
    button_icon: PropTypes.string,
  }).isRequired,
}

export default CookieNotice
